import { render, staticRenderFns } from "./StorageQueryProductChannel.vue?vue&type=template&id=1608a11c&"
import script from "./StorageQueryProductChannel.vue?vue&type=script&lang=ts&"
export * from "./StorageQueryProductChannel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StorageQueryProductChannel.vue"
export default component.exports